import { AxiosService } from "./implementations/axios.service";
import { useAuth } from "#imports";
import type { NuxtApp } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  // Capture auth once at plugin init time to avoid calling useAuth() during requests
  // which may execute outside the valid Nuxt composition context (e.g., during SSR)
  const auth = useAuth();
  const axios: AxiosService = new AxiosService(nuxtApp as NuxtApp, () => auth);
  return {
    provide: {
      axios: axios,
    },
  };
});